import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ContentWrapper = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

ContentWrapper.propTypes = {
  children: PropTypes.any,
};

const Wrapper = styled.div`
  > div {
    margin-top: -67px;
    min-height: 100vh;
    background-color: #f2f4f6;
  }
`;

export default ContentWrapper;
